import { _setLocalStore,_getLocalStore} from '../../lib/storage'
export default {
    state: {
        activeIndex: 0,//menu打开的name
    },
    getters: {
        getActiveIndex(state) {
            let newIndex = _getLocalStore('activeIndex')
            if(newIndex){
                return _getLocalStore('activeIndex')
            }else{
                return state.activeIndex

            }
        },
    },
    mutations: {
        addMenuList(state, data) {
           let result =  _getLocalStore('activeIndex')
            state.activeIndex = data
        },
    }
}
